/* RocketFuel cart line upgrade chips (markup: snippets/rf-cart-line.liquid).
   A chip sets the line to 2 or 3 boxes through the theme's own quantity selector,
   so the cart updates, re-renders and shimmers exactly like the + button does. */
(function () {
  if (window.rfCartLineInit) return;
  window.rfCartLineInit = true;

  document.addEventListener('click', function (event) {
    var chip = event.target.closest && event.target.closest('[data-rf-upgrade]');
    if (!chip) return;
    event.preventDefault();

    var qty = parseInt(chip.getAttribute('data-rf-upgrade'), 10);
    var row = chip.closest('.cart-items__table-row');
    if (!row || !qty) return;

    var group = chip.closest('[data-rf-upgrade-group]');
    if (group) group.classList.add('is-busy');

    var selector = row.querySelector('cart-quantity-selector-component, quantity-selector-component');
    if (selector && typeof selector.setValue === 'function' && typeof selector.onQuantityChange === 'function') {
      selector.setValue(String(qty));
      if (typeof selector.updateButtonStates === 'function') selector.updateButtonStates();
      selector.onQuantityChange();
      return;
    }

    /* Fallback: drive the number input like a shopper typing a new quantity. */
    var input = row.querySelector('input[type="number"]');
    if (input) {
      input.value = String(qty);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
})();

/* Trial Pack: one per order. snippets/rf-cart-line.liquid marks a Trial Pack line with a
   quantity above 1 (data-rf-tp-over). Set it back to 1 through the theme's own quantity
   selector (same path as the upgrade chips above), remember that for this tab, and show a
   short note on the line once it is back at 1. The theme morphs the cart after every
   change, so the note is put back after each render (only written when missing). */
(function () {
  if (window.rfTrialCapInit) return;
  window.rfTrialCapInit = true;

  var KEY = 'rfTpCapped';
  var DE = (document.documentElement.lang || '').toLowerCase().indexOf('de') === 0;
  var NOTE = DE
    ? 'Das Probierpaket gibt es nur einmal pro Bestellung, deshalb haben wir die Menge auf 1 gesetzt.'
    : 'The Trial Pack is limited to one per order, so we set the quantity to 1.';
  var busyUntil = 0;

  function flag(value) {
    try {
      if (value === undefined) return sessionStorage.getItem(KEY) === '1';
      if (value) sessionStorage.setItem(KEY, '1');
      else sessionStorage.removeItem(KEY);
    } catch (e) {}
    return false;
  }

  function cap(over) {
    if (Date.now() < busyUntil) return;
    var row = over.closest('.cart-items__table-row') || over.closest('li, tr');
    if (!row) return;
    busyUntil = Date.now() + 2000;
    flag(true);
    var selector = row.querySelector('cart-quantity-selector-component, quantity-selector-component');
    if (selector && typeof selector.setValue === 'function' && typeof selector.onQuantityChange === 'function') {
      selector.setValue('1');
      if (typeof selector.updateButtonStates === 'function') selector.updateButtonStates();
      selector.onQuantityChange();
      return;
    }
    var input = row.querySelector('input[type="number"]');
    if (input) {
      input.value = '1';
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function check() {
    var over = document.querySelector('[data-rf-tp-over]');
    if (over) {
      cap(over);
      return;
    }
    var limits = document.querySelectorAll('.rf-cl__limit');
    if (!limits.length) {
      // Trial Pack no longer in a rendered cart: forget the note.
      if (flag() && document.querySelector('cart-items-component .cart-items__table-row')) flag(false);
      return;
    }
    if (!flag()) return;
    limits.forEach(function (limit) {
      var next = limit.nextElementSibling;
      while (next && next.classList.contains('rf-cl__tp-used')) next = next.nextElementSibling;
      if (next && next.classList.contains('rf-cl__tp-capped')) return;
      var note = document.createElement('p');
      note.className = 'rf-cl__tp-capped';
      note.textContent = NOTE;
      limit.parentNode.insertBefore(note, limit.nextElementSibling);
    });
  }

  var timer = null;
  function queue() {
    clearTimeout(timer);
    timer = setTimeout(check, 80);
  }
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', queue);
  else queue();
})();
